import * as React from "react";
import { createContext, useContext } from "react";
import { MfaDeliveryMethod } from "@/services/bedrock/dtos";

export type Step = "SELECT_METHOD" | "ENTER_CODE" | "VERIFYING_PASSKEY" | "PROMPT_SETUP";

export interface MfaChallengeContextValue {
  step: Step;
  setStep: (step: Step) => void;
  method: MfaDeliveryMethod | "passkey" | null;
  setMethod: (method: MfaDeliveryMethod | "passkey" | null) => void;
  code: string;
  setCode: (code: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  hasPasskey: boolean | null;
  setHasPasskey: (hasPasskey: boolean | null) => void;
  error: string | null;
  setError: (error: string | null) => void;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
  onCancel: () => void;
}

export const MfaChallengeContext = createContext<MfaChallengeContextValue | undefined>(undefined);

export const useMfaChallengeContext = () => {
  const context = useContext(MfaChallengeContext);
  if (!context) {
    throw new Error("useMfaChallengeContext must be used within an MfaChallengeProvider");
  }
  return context;
};
